import { useState } from 'react';
import { Datagrid, TextField, DateField, useDataProvider, useNotify, useRefresh, useRecordContext } from 'react-admin';
import { PartiallyHiddenCpfField } from '../../components/Fields';
import ListPagination from '../../components/ListPagination';
import { Permission, ReportList } from '../../components';
import { PERMISSIONS } from '../../constants';
import { SxProps, Theme } from '@mui/material/styles';
import { Button, CircularProgress } from '@mui/material';
import RestoreIcon from '@mui/icons-material/Restore';

const restoreButtonSx: SxProps<Theme> = {
  minWidth: '120px',
};

const RestoreButton = () => {
  const record = useRecordContext();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const [loading, setLoading] = useState(false);

  if (!record) return null;

  const handleRestore = async () => {
    if (!window.confirm('Deseja restaurar este cliente?')) return;
    setLoading(true);
    try {
      await dataProvider.create(`customers/${record.id}/restore`, { data: {} });
      notify('Cliente restaurado com sucesso!', { type: 'success' });
      refresh();
    } catch (error) {
      notify('Erro ao restaurar cliente', { type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      sx={restoreButtonSx}
      onClick={handleRestore}
      disabled={loading}
      color="primary"
      variant="outlined"
      size="small"
      startIcon={loading ? <CircularProgress size={16} /> : <RestoreIcon />}
    >
      {loading ? 'Restaurando...' : 'Restaurar'}
    </Button>
  );
};

const ReportCLientDeleted = (props) => {
  return (
    <Permission permission={PERMISSIONS.CUSTOMERS_DELETED} >
      <ReportList
        {...props}
        exporter={false}
        bulkActionButtons={false}
        basePath='customers-deleted'
        resource='chains/chainId/reports/customers-deleted'
        title="Clientes excluídos"
        sort={{ field: 'deletedAt', order: 'DESC' }}
        titleOnPrint="Clientes excluídos"
        perPage={25}
        pagination={<ListPagination />}
        landscape
      >
        <Datagrid bulkActionButtons={false}>
          <TextField source="name" label="Nome" />
          <PartiallyHiddenCpfField source="cpf" label="CPF" textAlign="center" />
          <DateField source="deletedAt" label="Data de exclusão" showTime locales="pt-BR" />
          <RestoreButton />
        </Datagrid>
      </ReportList>
    </Permission>
  );
};
export default ReportCLientDeleted;
